import { MISSION_ROLE_APPLICANT_VIEWS_COUNT } from "graphql/queries";
import useQueryData from "hooks/useQueryData";

export default function useMissionRoleApplicantViewsCount({ ids, skip }) {
  const { data, loading, error } = useQueryData({
    queryName: MISSION_ROLE_APPLICANT_VIEWS_COUNT,
    variables: { ids },
    skip: !ids || ids.length === 0 || skip,
    keyName: "missionRoleApplicantViewsCount",
  });

  return {
    data,
    loading,
    error,
  };
}
